import React, { useEffect, useState } from 'react';
import {
  Row,
  Col,
  FormGroup,
  Label,
  Modal,
  ModalHeader,
  ModalBody,
  Input,
  Table
} from 'reactstrap';
import { connect } from 'react-redux';
import moment from 'moment';

const ViewQueryModal = ({ isOpen, handleClose, queryData }) => {
  const [auditLogs, setAuditLogs] = useState([]);
  useEffect(() => {
    if (queryData) {
      setAuditLogs(queryData?.auditLogs?.filter((log) => log.user) || []);
    }
  }, [queryData]);
  return (
    <React.Fragment>
      <Modal isOpen={isOpen} backdrop="static" size="lg">
        <ModalHeader toggle={handleClose}>Query Details</ModalHeader>
        <ModalBody>
          <Row className="mb-2">
            <Col md="6">
              <FormGroup>
                <Label>Parent</Label>
                <Input
                  name="parentName"
                  type="text"
                  className="form-control"
                  defaultValue={queryData?.parentName}
                  readOnly
                />
              </FormGroup>
            </Col>
            <Col md="6">
              <FormGroup>
                <Label>Child</Label>
                <Input
                  name="childName"
                  type="text"
                  className="form-control"
                  defaultValue={queryData?.childName}
                  readOnly
                />
              </FormGroup>
            </Col>
            <Col md="12">
              <FormGroup>
                <Label>Query</Label>
                <Input
                  name="query"
                  type="textarea"
                  className="form-control"
                  defaultValue={queryData?.query}
                  readOnly
                />
              </FormGroup>
            </Col>
            <Col md="12">
              <FormGroup>
                <Label>Answer</Label>
                <Input
                  name="answer"
                  type="text"
                  className="form-control"
                  defaultValue={queryData?.answer}
                  readOnly
                />
              </FormGroup>
            </Col>
          </Row>

          <Row>
            <Col md="12">
              <h5>Audit Logs</h5>
            </Col>
            <Col
              md="12"
              style={{
                maxHeight: '15rem',
                overflow: 'auto',
                scrollbarWidth: 'none',
                msOverflowStyle: 'none'
              }}
            >
              <div className="table-rep-plugin">
                <div
                  className="table-responsive mb-0"
                  data-pattern="priority-columns"
                >
                  <Table id="tech-companies-1" striped bordered responsive>
                    <thead>
                      <tr>
                        <th>User</th>
                        <th>Action</th>
                        <th>Timestamp</th>
                      </tr>
                    </thead>
                    {auditLogs?.length === 0 ? (
                      <tbody>
                        <tr>
                          <td colSpan={4} className="text-center">
                            No Logs Available
                          </td>
                        </tr>
                      </tbody>
                    ) : (
                      <tbody>
                        {auditLogs?.map((log, index) => (
                          <tr key={index}>
                            <td>{log?.user?.name || log.userType}</td>
                            <td>{log?.message || 'N/A'}</td>
                            <td>
                              {moment(log?.timestamp).format(
                                'DD MMM YYYY HH:mm A'
                              ) || 'N/A'}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    )}
                  </Table>
                </div>
              </div>
            </Col>
          </Row>
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    authUser: state.Login?.user
  };
};

export default connect(mapStateToProps)(ViewQueryModal);
